import React from 'react';

export const PlaySvg = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.36479 4.11953L2.18833 0.793746C1.5221 0.435006 0.714233 0.917542 0.714233 1.67422V8.32578C0.714233 9.08246 1.5221 9.56499 2.18833 9.20625L8.36479 5.88047C9.06599 5.5029 9.06599 4.4971 8.36479 4.11953Z"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);
